import styled from 'styled-components';
import { rem } from 'polished';
import Day from './day';

const StyledDay = styled(Day)`
  position: relative;
  top: ${rem('-17px')};
  margin-right: ${rem('10px')};
`;
export { StyledDay };
